.janeGoldDetailMain {
  padding: 0 24px 24px;
}

.janeGoldDetailBreadcrumbs {
  margin-top: 8px;
}

@media all and (--reefer-media-tablet-min) {
  .janeGoldDetailMain {
    padding: 0 64px 48px;
  }

  .janeGoldDetailBreadcrumbs {
    margin-top: 16px;
  }
}
